module.exports = __webpack_public_path__ + "img/logo-white.1e5d1949.png";